import React from 'react';
import CardContainer from './styles';
import PropTypes from 'prop-types';
import { Typography, Box } from '@material-ui/core';

const Information = ({ icon, title, description, detail }) => (
	<CardContainer>
		<Box className="information__icon">{icon}</Box>
		<Box>
			<Typography color="textPrimary" className="information__title">
				{title}
			</Typography>
			<Box mt={0.5}>
				<Typography color="textPrimary" className="information__description">
					{description}
				</Typography>
				<Typography color="textPrimary" className="information__description">
					{detail}
				</Typography>
			</Box>
		</Box>
	</CardContainer>
);

export default Information;

Information.defaultProps = {
	title: ''
};

Information.propTypes = {
	icon: PropTypes.string,
	title: PropTypes.string.isRequired,
	description: PropTypes.string
};
